import script from "./TableDataUserIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableDataUserIcon.vue?vue&type=script&setup=true&lang=ts"

import "./TableDataUserIcon.vue?vue&type=style&index=0&id=7d53ba57&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d53ba57"]])

export default __exports__